<template>
  <div class="text-options-data-dialog" :key="ids.elementInLayoutId">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div>
          <div v-if="!isLoginType" class="data-source-type">
            <cx-slider :value.sync="notLocal" :options="dataOptions" :height="32" />
          </div>
          <div v-show="pageType !== 'detailPage' && pageType !== 'listPage' && noCacheComponent && !noCacheComponentLayout && options.dataType !== '3'" :class="pageType !== 'detailPage' && pageType !== 'listPage' && noCacheComponent && !noCacheComponentLayout ? 'mt12' : ''">
            <data-center-choose
              :checkStatus="checkStatus"
              :myId="ids"
              :options="options"
              @onDataCenterChange="onDataCenterChange"
            />
          </div>
          <!-- <div v-show="!notLocal" :class="!noCacheComponent ? 'content-item verticallyCenter mt12' : 'content-item verticallyCenter'">
            
          </div> -->
        </div>
      </el-collapse-item>
      <el-collapse-item title="目标时间" v-show="!notLocal" name="4">
        <el-date-picker
          v-model="content"
          class="countdown-date-picker"
          type="datetime"
          placeholder="选择时间">
        </el-date-picker>
      </el-collapse-item>
      <el-collapse-item
        v-if="(pageType === 'detailPage' || pageType === 'listPage') && ((noCacheComponent && !showColsFieldMapping) || (noCacheComponentLayout && notLocal && multiImageDetail))"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="数据绑定"
        name="2"
      >
        <div v-if="pageType === 'detailPage'">
          <detailPageFieldMappingSetting v-if="noCacheComponent && !showColsFieldMapping" :myid="ids" :options="options"></detailPageFieldMappingSetting>
          <multiImageFieldMappingSetting v-else :myid="ids" :options="options"></multiImageFieldMappingSetting>
        </div>
        <div v-else-if="pageType === 'listPage'">
          <listPageFieldMappingSetting :myid="ids" :options="options"></listPageFieldMappingSetting>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-else-if="(showColsFieldMapping && (noCacheComponentLayout || hasGetDetailDataPlugin) && notLocal) || (!noCacheComponentLayout && noCacheComponent) || dataType === '3'"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="数据绑定"
        name="2"
      >
        <div v-if="!noCacheComponentLayout && noCacheComponent || dataType === '3'" :class="currentFieldMappingFieldFlag ? 'mapping_content checked' : 'mapping_content'">
          <div class="verticallyBetweenCenter">
            <div class="content-title">
              {{ getValueByTypeHandle(options.innerElement) }}
            </div>
          </div>
          <div class="select_content mt8">
            <el-select
              style="width: 100%"
              v-model="currentFieldMappingFieldFlag"
              placeholder="请选择"
              clearable
            >
              <el-option v-for="(item, index) in currentFieldMappingList" :key="index" :label="item.label" :value="item.value">
                <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="verticallyCenter mapping_date_content mt8">
            <label class="date-label">显示为:</label>
            <el-dropdown trigger="click" @command="onChangeMappingType">
              <span class="el-dropdown-link">
                {{ fieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'">
                <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
                  <div :class="fieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                    {{ item.label }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <colsFieldMappingSetting :ids="dataIds" :myId="ids" :options="options" v-else></colsFieldMappingSetting>
      </el-collapse-item>
    </el-collapse>
    <asyncPluginSettingSubmit
      :pluginName="options.pluginName"
      componentName="text"
      :options="options"
      type="Data"
      :rect_id="rect_id"
      :container_id="container_id"
    />
  </div>
</template>

<script>
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue"
import multiImageFieldMappingSetting from "publicSetting/multiImageFieldMappingSetting.vue"
import listPageFieldMappingSetting from "publicSetting/listPageFieldMappingSetting.vue"
import { getValueByType, isExist } from "utils"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import { historyIgnoreWrap } from "utils/revork"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
import dataToolMixin from "materials/dataToolMixin"

export default {
  name: "countdown-options-data",
  components: { detailPageFieldMappingSetting, multiImageFieldMappingSetting, listPageFieldMappingSetting, autoUpdateTimer, colsFieldMappingSetting, dataCenterChoose },
  mixins: [dataToolMixin],
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2", "3", "4"],
      collapseActiveNames: [],
      fetchEnd: false,
      currentFieldMappingList: [],
      explainDialog: false,
      dataTypeList: [
        {
          label: "字段名称+字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      conditionList1: ["数值", "文本"],
      conditionList: ["等于", "不等于", "大于", "小于", "大于等于", "小于等于", "介于"],
      conditionList2: ["等于", "不等于"]
    }
  },
  mounted() {
    this.originalIds = JSON.parse(JSON.stringify(this.$store.state.states.activeID))
    if (this.noCacheComponentLayout && !this.isBigScreen) {
      historyIgnoreWrap(() => {
        this.noCacheComponent = false
      })()
    }
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  updated() {
    this.originalIds = JSON.parse(JSON.stringify(this.$store.state.states.activeID))
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  watch: {
    currentFiledMapping: {
      deep: true,
      handler(n, o) {
        if (n && n.isChecked) {
          if (this.currentFieldMappingList.length > 0) {
            this.currentFieldMappingList.forEach((item, index) => {
              if (item.value === n.fieldFlag) {
                let value = item.content
                switch (n.dataType) {
                  case "dataKey":
                    value = item.label + "：" + item.content
                    break
                  case "dataName":
                    value = item.label
                    break
                  default:
                    value = item.content
                }
                // 数据为空时显示内容
                if (this.emptyDataShowLocal && !item.content?.length) {
                  value = this.emptyContent
                }
                this.content = value
              }
            })
          }
        }
      }
    }
  },
  computed: {
    showColsFieldMapping() {
      return this.dataIds?.uid || isExist(this.dataIds?.elementInSwiperId) || this.dataIds?.elementInDataGridId
    },
    linkAddress: {
      get() {
        return this.options.linkAddress || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkAddress", false)
      }
    },
    isBigScreen() {
      return this.request_prefix === "bigScreen"
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    content: {
      get() {
       return this.options.endTime
      },
      set(newVal) {
        // 用this.originalIds的原因: content的set是由失去焦点触发的，如果是通过点击其他元素，比如点击
        // 某个按钮触发时，由于点击动作本身会改变this.$store.state.states.activeID的值, 会导致
        //  this.$changeOptionsEv执行时，通过ids找数据拿到的就是后面被点击那个元素的ids，导致设置错
        this.$changeOptionsEV(newVal, "endTime", false, undefined, this.originalIds, this.noCacheComponent)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBlankPage", false)
      }
    },
    internalLinkName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "internalLinkName", "internalLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "internalLinkName", false)
      }
    },
    subLinkName: {
      get(val) {
        return this.checkAndSetPrimaryVal(this.options, "subLinkName", "subLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "subLinkName", false)
      }
    },
    needLinkSetComponent(){
      if(this.hasFiledMapping){
        return false
      }
      if (this.isLoginType) return false // 登录框业务组件
      if (this.layoutOptions && this.layoutOptions.componentTypeName ==="cxSystemSearch"){
        return true
      } else if (this.layoutOptions?.pluginName && this.layoutOptions?.pluginName[0] === "loginLayoutComponent") {
        return true
      } else if (this.layoutOptions?.pluginName && this.layoutOptions?.pluginName [0] === 'loginEngineComponentPlugin'){
        return true
      } else if(this.layoutOptions?.menuName === '超星头像'){
        return  true
      } else {
        return  false
      }
    },
    linkUrl: {
      get() {
        return this.options.linkUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrl", false)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    openUVScan: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openUVScan", "openUVScan", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openUVScan", false)
      }
    },
    getDataCount: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "getDataCount", "getDataCount", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "getDataCount", false)
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    filedMapping: {
      get() {
        return this.options.filedMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping", false)
      }
    },
    notLocal: {
      get() {
        if(this.noCacheComponentLayout) {
          return !!this.options.filedMapping?.value
        } else if (this.dataType === "3") {// 匹配分类字段
          return this.dataType
        } else {
          return this.noCacheComponent
        }
      },
      set(newVal) {
        if(this.noCacheComponentLayout) {
          if (!this.filedMapping) this.filedMapping = {}
          if (this.searchComponentPlugin) {
            this.$changeOptionsEV(newVal ? "name" : "", "filedMapping.value", false)
          } else {
            this.$changeOptionsEV(newVal ? "0" : "", "filedMapping.value", false)
          }
        } else if (newVal === '3') {
          this.dataType = newVal
          this.noCacheComponent = false
        } else {
          this.noCacheComponent = newVal
        }
        if (this.dataType && newVal !== '3') this.dataType = "" // 清空
      }
    },
    dataType: {
      get() {
        return this.options.dataType
      },
      set(newVal) {
        if (newVal === '3') {
          this.currentFieldMappingList = this.getClassifyData()
        } else {
          this.currentFieldMappingList = []
        }
        this.$changeOptionsEV(newVal, "dataType", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
        // 如果在详情页中文本组件选中外接数据源，需要先初始化文本组件在详情页的相关对象属性detailFieldMapping，同时给文本组件增加在详情页中请求数据源的插件
        // 切换到本都数据的时候，清除之前绑定的appId
        if (!newVal) {
          this.$changeOptionsEV("", "appId", false, false, false, true)
        }
        if ((this.pageType === "detailPage" || this.pageType === "listPage") && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataKey",
              fieldFlag: ""
            },
            "detailFieldMapping",
            false,
            false,
            false,
            true
          )
        }
        if (this.pageType !== "detailPage" && this.pageType !== "listPage" && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataKey",
              fieldFlag: ""
            },
            "currentFiledMapping",
            false,
            false,
            false,
            true
          )
        }
      }
    },
    accessRulers: {
      get() {
        return this.options.accessRulers ? this.options.accessRulers : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "accessRulers", false)
      }
    },
    hasFiledMapping(){
      // 判断当前文本是否绑定了外接数据源
      if(this.currentFiledMapping && this.currentFiledMapping.flag){
        return true
      }
      if(this.options.filedMapping && this.options.filedMapping.flag){
        return true
      }
      return  false
    },
    currentFiledMapping: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "currentFiledMapping", "currentFiledMapping", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping", false)
      }
    },
    currentFiledMappingChecked: {
      get() {
        return this.options.currentFiledMapping?.isChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.isChecked", false)
      }
    },
    currentFieldMappingFieldFlag: {
      get() {
        return this.options.currentFiledMapping?.fieldFlag
      },
      set(newVal) {
        if(!this.currentFiledMappingChecked) {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
          this.$changeOptionsEV(true, "currentFiledMapping.isChecked", false, false, false, true)
        } else {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
        }
      }
    },
    fieldMappingDataType: {
      get() {
        return this.currentFiledMapping?.dataType || "dataValue"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    fieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.fieldMappingDataType)
      return item?.label || ""
    },
    isLoginType(){
      return this.options.loginType
    },
    searchComponentPlugin() {
      return this.layoutOptions?.pluginName?.includes("searchComponentPlugin")
    },
    linkLoading: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "linkLoading", "linkLoading", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkLoading", false)
      }
    },
    emptyDataShowLocal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyDataShowLocal", "emptyDataShowLocal", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyDataShowLocal", false, null)
      }
    },
    emptyContent: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyContent", "emptyContent", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyContent", false, null)
      }
    },
    emptyFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyFontFamily", "emptyFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontFamily", false)
      }
    },
    emptyFontSize: {
      get() {
        return this.options.emptyFontSize || 24
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontSize", false)
      }
    },
    emptyFontWeight: {
      get() {
        return this.options.emptyFontWeight || 400
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontWeight", false)
      }
    },
    emptyFontColor: {
      get() {
        return this.options.emptyFontColor || "rgba(0, 0, 0, 0.8)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontColor", false)
      }
    },
    showEditCacheValue: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showEditCacheValue", "showEditCacheValue", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showEditCacheValue", false, null)
      }
    },
    onWarning: {
      get() {
        return this.options.onWarning || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "onWarning", false, null)
      }
    },
    dynamicData: {
      get() {
        if (this.onWarning) {
          // 序列表格才有数据组
          return this.options.dynamicData || []
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dynamicData", false, null)
      }
    },
    warningFieldShow() {
      return this.noCacheComponent || this.noCacheComponentLayout
    },
    warningMappingFieldFlag:{
      get() {
        return this.options.warningMappingFieldFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningMappingFieldFlag", false)
      }
    },
    warningFieldMappingList: {
      get() {
        return this.options.warningFieldMappingList || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningFieldMappingList", false, false, false, true)
      }
    },
    hasGetDetailDataPlugin() {
      return this.layoutOptions?.pluginName?.includes("getDetailDataPlugin")
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }]
      if (this.pageType === "detailPage" || this.pageType === "listPage" || this.showColsFieldMapping) {
        options.push({ value: true, title: "数据绑定" })
      } else if((this.isBigScreen && !this.noCacheComponentLayout) || (!this.isBigScreen && !this.showColsFieldMapping)) {
        if (this.directionTitle) {
          options.push({ value: "3", title: "数据绑定" })
        }
        options.push({ value: true, title: "数据中心" })
      }
      return options
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.dataIds)
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          if (typeof datas === "string") {
            return
          } else if(datas.length === 0){ //添加空数据情况
            if (this.emptyDataShowLocal) {
              this.content = this.emptyContent
            } else {
              if (this.isBigScreen) this.content = "暂无数据"
              else this.content = ""
            }
            this.$changeOptionsEV(true, "isEmptyData", false, null, this.ids, true)
            return
          }
          if (
            !this.options.currentFiledMapping ||
            (this.options.currentFiledMapping && !this.options.currentFiledMapping.isChecked)
          ) {
            /*大屏外接数据空数据展示位暂无数据*/
            if (datas.length === 0) {
              if (this.emptyDataShowLocal) {
                this.content = this.emptyContent
              } else {
                if (this.isBigScreen) this.content = "暂无数据"
                else this.content = ""
              }
              this.$changeOptionsEV(true, "isEmptyData", false, null, this.ids, true)
            } else {
              this.$changeOptionsEV(false, "isEmptyData", false, null, this.ids, true)
              this.content = datas[0][Object.keys(datas[0])[0]].value
            }
          } else if (this.options.currentFiledMapping && this.options.currentFiledMapping.fieldFlag) {
            this.$changeOptionsEV(false, "isEmptyData", false, null, this.ids, true)
            const dataType = this.options.currentFiledMapping.dataType
            let data = datas[0][this.options.currentFiledMapping.fieldFlag]
            if(this.options.getDataCount){//兼容获取数据数量的情况
              data = datas[0][0]
            }
            let tempDataValue = data.value
            if (dataType === "dataKey") {
              tempDataValue = data.key + "：" + data.value
            } else if (dataType === "dataName") {
              tempDataValue = data.key
            }
            this.content = tempDataValue
          }
          // type: 是否要重新加入字段匹配下拉项 避免点击数据响应就加一次
          if (datas) {
            const list = []
            Object.keys(datas[0]).forEach((key, index) => {
              if (key === "content") return
              if (key && datas[0][key]?.value) {
                const temp = {
                  value: key,
                  label: datas[0][key].key,
                  content: datas[0][key].value
                }
                list.push(temp)
              }
            })
            this.currentFieldMappingList = list
            if(this.onWarning){
              this.warningFieldMappingList = list
            }
          }
        })
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    async getAppointData() {
      return this.instance.get(`engine2${this.restDataUrl.slice(8)}&p2=1`)
    },
    async getGeneralRest(appId, wfwfid, websiteId, pageId) {
      return this.$API.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: pageId
      })
    },
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    blurFunc($event) {
      this.content = $event.target.innerHTML
      sessionStorage.removeItem("isInputFocus")
    },
    focusFunc() {
      sessionStorage.setItem("isInputFocus", true)
    },
    // 开启/关闭浏览器
    changeScanNumType() {
      // todo  待后端出接口
    },

    // 删除数据条件 点击事件
    deleteDynamicDataHandle(index) {
      let dynamicData = JSON.parse(JSON.stringify(this.options.dynamicData))
      dynamicData.splice(index, 1)
      this.$changeOptionsEV(dynamicData, "dynamicData", false)
    },
    //
    getDynamicDataConditionHandle1(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".contentType", false)
    },
    // 数据改变条件
    getDynamicDataConditionHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".condition", false)
    },
    // 数据改变条件范围1
    getDynamicDataConditionRange1Handle(index, $event, index1) {
      let conditionRange = this.options.dynamicData[index].conditionRange
      conditionRange[index1] = $event
      this.$changeOptionsEV(conditionRange, "dynamicData." + index + ".conditionRange", false)
    },
    // 数据改变参数值
    getDynamicDataParameterHandle(index, $event) {
      this.$changeOptionsEV($event, "dynamicData." + index + ".parameter", false)
    },
    // 添加数据条件 点击事件
    addDynamicDataHandle() {
      let addDynamicData = {
        contentType: "数值", // 类型  数值；文本
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        conditionRange: [],
        parameter: "", // 参数值
        resultTextIsThemeColor: this.options.textIsThemeColor || false,
        resultColorArr: this.options.colorArr || {},
        resultActiveNameColor: this.options.activeNameColor || "first",
        resultBackground: this.options.background || [],
      }
      let dynamicData = []
      if(this.options.dynamicData !== undefined){
        dynamicData = JSON.parse(JSON.stringify(this.options.dynamicData))
      }
      dynamicData.push(addDynamicData)
      this.$changeOptionsEV(dynamicData, "dynamicData", false)
    },
    onChangeMappingType(value) {
      this.fieldMappingDataType = value
    },
    onDataCenterChange() {
      if(!this.noCacheComponentLayout && this.noCacheComponent) {
        this.getBaseModuleDataLoop()
      }
    },
    updateToolbarData() {
      if(!this.noCacheComponentLayout && this.noCacheComponent) {
        this.getBaseModuleDataLoop()
      }
      if (this.dataType === "3") {
        this.currentFieldMappingList = this.getClassifyData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .countdown-date-picker.el-input .el-input__inner {
    padding: 5px 0 5px 30px;
}
::v-deep .countdown-date-picker .el-input__icon {
  line-height: 32px;
}
.left-label {
  min-width: 60px;
}
.card {
  background: rgba(41, 44, 49, 1);
}
.count-limit-item::v-deep .el-input__inner {
  background: #35383f;
  padding: 0 12px;
  border-radius: 4px;
}

.setting-item .count-limit-item span {
  margin: 0 8px;
}
.setting-item .content-item .el-checkbox {
  margin-right: 20px;
}
.count-limit-item::v-deep .el-radio {
  margin-top: 7px;
  margin-bottom: 3px;
}

.count-limit-item::v-deep .el-radio:first-child {
  margin-top: 0;
}

.count-limit-item::v-deep .el-radio-group {
  width: 80px;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataType-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.dataUrl-item .tips {
  color: var(--thirdTextColor);
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px 4px 4px 12px;
  max-height: 156px;
  overflow-y: auto;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
.mt4 {
  margin-top: 4px;
}
.specialRows_content {
  border: 1px solid #313336;
  border-radius: 4px;
  padding: 12px;
  position: relative;
}
.specialRows_content .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--sliderBackGround);
  border-radius: 0px 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.specialRows_content .delete-btn .icon-portal-delete1 {
  top: 5px;
  left: 5px;
  position: absolute;
}
.specialRows_content .delete-btn .icon-portal-delete1:before {
  color: var(--toolbarTipText);
}
.specialRows_content .color-picker-container.custom-container-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
.addConditionBtn {
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  width: 102px;
  height: 32px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
    &.checked,
    &:hover {
      border-color: rgba(166, 139, 255, 0.16);
      background-color: rgba(166, 139, 255, 0.04);
    }
    .select_content {
      ::v-deep .el-input__inner {
        background-color: rgba(31, 33, 36, 1);
        box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset;
      }
    }
    &.checked {
      .select_content {
        ::v-deep .el-input__inner {
          background-color: rgba(166, 139, 255, 0.1);
          color: rgba(166, 139, 255, 1);
          box-shadow: 0px 0px 0px 1px rgba(166, 139, 255, 0.16) inset;
          &:hover {
            background-color: rgba(166, 139, 255, 0.2);
          }
        }
        ::v-deep .el-select__caret {
          color: rgba(166, 139, 255, 1);
        }
        ::v-deep .is-focus .el-input__inner {
          background-color: rgba(166, 139, 255, 0.2);
        }
      }
    }
  }
}
.custom-dropdown.bigScreen {
  .dropdown-title-show {
    border-color: rgba(55, 55, 55, 1);
  }
  ::v-deep .el-dropdown-menu__item {
    color: rgba(255, 255, 255, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
</style>
<style>
.width200 {
  width: 200px;
}
</style>
